'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = require('react-bootstrap');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
Component: LoaderComponent (Original Author: Akshay Tak)

Usage: To show loader with customisable color

LOADER IS COPIED FROM SOME OTHER NPM PACKAGE SO CSS IS INCLUDED IN THE COMPONENT

*/

var svg_style = {
    animation: 'rotate 2s linear infinite',
    height: '100%',
    transformOrigin: 'center center',
    width: '100%',
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    margin: 'auto'
};

var circle_style = {
    strokeDasharray: '1,200',
    strokeDashoffset: '0',
    animation: 'dash 1.5s ease-in-out infinite, color 6s ease-in-out infinite',
    strokeLinecap: 'round'
};

var LoaderComponent = function (_React$Component) {
    _inherits(LoaderComponent, _React$Component);

    function LoaderComponent(props) {
        _classCallCheck(this, LoaderComponent);

        var _this = _possibleConstructorReturn(this, (LoaderComponent.__proto__ || Object.getPrototypeOf(LoaderComponent)).call(this, props));

        _this.getShades = function (colorsArr) {

            var color = '0% { stroke: ' + colorsArr[0] + ' } ';
            var count = 0;
            for (var i = 1; i < 6; i++) {
                count = count + 1;
                count = count === colorsArr.length ? 0 : count;
                color = color + (i * 2 + '0% { stroke: ' + colorsArr[count] + '; } ');
            }

            return color;
        };

        _this.animation = function (loaderColor) {
            return '@keyframes rotate {\n            100% {\n                transform: rotate(360deg);\n            }\n        }\n        @keyframes dash {\n            0% {\n                stroke-dasharray: 1,200;\n                stroke-dashoffset: 0;\n            }\n            50% {\n                stroke-dasharray: 89,200;\n                stroke-dashoffset: -55px;\n            }\n            100% {\n                stroke-dasharray: 89,200;\n                stroke-dashoffset: -124px;\n            }\n        }\n        @keyframes color {\n           ' + (Array.isArray(loaderColor) && loaderColor.length ? _this.getShades(loaderColor) : '100%, 0% { stroke: ' + loaderColor + '; }') + '\n            \n        }';
        };

        _this.loading_style = function (width, height) {

            return {
                position: 'relative',
                margin: '0px auto',
                width: width,
                height: height
            };
        };

        _this.state = {
            browserIE: false
        };
        return _this;
    }

    _createClass(LoaderComponent, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            if (navigator.userAgent.toLowerCase().indexOf('.net') > -1) this.setState({ browserIE: true });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                width = _props.width,
                height = _props.height,
                isLoading = _props.isLoading,
                loaderColor = _props.loaderColor,
                blockUI = _props.blockUI;


            if (isLoading) {
                if (this.state.browserIE || blockUI) {
                    return _react2.default.createElement(
                        _reactBootstrap.Modal,
                        { bsSize: 'small', 'aria-labelledby': 'contained-modal-title-sm', show: this.props.isLoading, keyboard: false },
                        _react2.default.createElement(
                            _reactBootstrap.Modal.Body,
                            null,
                            _react2.default.createElement(
                                'div',
                                { style: { textAlign: 'center', fontSize: 18, paddingBottom: '1rem' } },
                                ' Please Wait... '
                            ),
                            _react2.default.createElement(
                                'div',
                                { style: this.loading_style(width, height) },
                                _react2.default.createElement(
                                    'style',
                                    null,
                                    this.animation(loaderColor),
                                    '>'
                                ),
                                _react2.default.createElement(
                                    'svg',
                                    { style: svg_style, viewBox: '25 25 50 50' },
                                    _react2.default.createElement('circle', { style: circle_style, cx: '50', cy: '50', r: '20', fill: 'none', strokeWidth: '7', strokeMiterlimit: '10' })
                                )
                            )
                        )
                    );
                } else {
                    return _react2.default.createElement(
                        'div',
                        { style: this.loading_style(width, height) },
                        _react2.default.createElement(
                            'style',
                            null,
                            this.animation(loaderColor),
                            '>'
                        ),
                        _react2.default.createElement(
                            'svg',
                            { style: svg_style, viewBox: '25 25 50 50' },
                            _react2.default.createElement('circle', { style: circle_style, cx: '50', cy: '50', r: '20', fill: 'none', strokeWidth: '7', strokeMiterlimit: '10' })
                        )
                    );
                }
            } else {
                return null;
            }
        }
    }]);

    return LoaderComponent;
}(_react2.default.Component);

LoaderComponent.propTypes = {
    isLoading: _propTypes2.default.bool,
    blockUI: _propTypes2.default.bool,
    width: _propTypes2.default.string,
    height: _propTypes2.default.string
};

LoaderComponent.defaultProps = {
    isLoading: true,
    blockUI: false,
    width: '40px',
    height: '40px',
    loaderColor: "#808080"
};

exports.default = LoaderComponent;

/**
 * 
 *  0% {
                stroke: green;
            }
            20%{
                stroke: red;
            }
            40% {
                stroke: yellow;
            }
            60% {
                stroke: green;
            }
            80% {
                stroke: red;
            }
            100% {
                stroke: yellow;
            }
 * 
 */


//////////////////
// WEBPACK FOOTER
// ./node_modules/dataphi-react-components/dist/Containers/DataphiLoader/Component/LoaderComponent.js
// module id = 1568
// module chunks = 0